import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';

export const HelpSkeleton = () => {
	return (
		<Box backgroundColor="elevation.surface" xcss={heightXcss}>
			<Stack grow="fill">
				<Box
					paddingBlock="space.200"
					paddingInline="space.100"
					xcss={borderBottomXcss}
					backgroundColor="color.background.neutral"
				>
					<Inline spread="space-between" alignBlock="center">
						<Inline alignInline="center" grow="fill" alignBlock="center">
							<Skeleton width={40} height={16} borderRadius={3} />
						</Inline>
						<Skeleton width={32} height={32} borderRadius={3} />
					</Inline>
				</Box>
				<Box padding="space.200" backgroundColor="elevation.surface">
					<Stack grow="fill">
						<Box padding="space.050">
							<Inline space="space.100">
								<Skeleton width={32} height={32} borderRadius={3} />
								<Skeleton width={100} height={32} borderRadius={3} />
							</Inline>
						</Box>
					</Stack>
				</Box>
			</Stack>
		</Box>
	);
};

const borderBottomXcss = xcss({
	borderBottomWidth: 'border.width',
	borderBottomStyle: 'solid',
	borderBottomColor: 'color.border',
});

const heightXcss = xcss({
	height: '100%',
});
